import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { EditCampaignsConstants } from '../../typings/campaignsEdit';
import { CommonData } from '../../typings/common';
import { ConstStrategyData } from '../../typings/constants';
import { State } from '../../typings/state';
import { StrategyEditorData } from '../../typings/strategyEditor';

export const selectStrategyEditorData = createCachedSelector(
    (state: State, editorId: string): StrategyEditorData => state.strategyEditor.editors[editorId],
    (editorData: StrategyEditorData): StrategyEditorData => editorData
)((state: State, editorId: string): string => editorId);

export const selectStrategyEditorConstsData = createSelector(
    (state: State): CommonData => state.commonData,
    (state: State): EditCampaignsConstants | undefined => state.editCampaigns.constants,
    (commonData: CommonData, editCampaignConstants?: EditCampaignsConstants): ConstStrategyData | undefined => {
        const {
            client: { workCurrency },
            constants
        } = commonData;
        if (constants && editCampaignConstants) {
            return {
                ...constants.currencyConstants[workCurrency],
                roiCoefMin: editCampaignConstants.roiCoefMin,
                payForConversionSumToAvgCpaMinRatio: editCampaignConstants.payForConversionSumToAvgCpaMinRatio
            };
        }
        return undefined;
    }
);
